import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ComponentList from '~/client/components/component-list/component-list';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import PreviewCard from '~/client/components/preview-card/preview-card';
import type { BootCampConceptsLandingPage as Props } from './boot-camp-concepts-landing-page.types';

const BootCampConceptsLandingPage: React.FC<Props> = ({
  concepts,
  layout,
  title,
}) => (
  <Layout {...layout}>
    <div className="boot-camp-concepts-landing-page">
      <div className="boot-camp-concepts-landing-page__header">
        <ContentContainer theme={ContentContainer.themes.wide}>
          <Text theme={Text.themes.headline} size={Text.sizes.headline2} italic>
            {title}
          </Text>
        </ContentContainer>
      </div>
      <ContentContainer theme={ContentContainer.themes.wide}>
        <div className="boot-camp-concepts-landing-page__inner">
          <ComponentList {...concepts} entryRenderer={PreviewCard} />
        </div>
      </ContentContainer>
    </div>
  </Layout>
);

export default BootCampConceptsLandingPage;
